import React, {Fragment} from 'react'
import I18n from 'i18n-js'
import yup from '../../../lib/YupValidations'
import {
  ResetPasswordFormLabel,
  ResetPasswordFormMessage,
} from './ResetPasswordForm.styled'
import Form from '../../shared/Form'
import Button from '../../shared/Button'
import * as PropTypes from 'prop-types'

const formFields = [
  {
    component: 'input',
    id: 'verificationCode',
    label: I18n.t('auth.verificationCode'),
    name: 'verificationCode',
    validation: yup.string().required(),
  },
  {
    id: 'password',
    label: I18n.t('shared.password'),
    name: 'password',
    type: 'password',
    customValidation: true,
    passwordHelper: true,
    validation: yup
      .string()
      .required('Password is required.')
      .min(6, I18n.t('errors.passwordFieldError'))
      .max(40, 'Password is too long.')
      .matches(/(?=.*[A-Z])/, I18n.t('errors.passwordFieldError'))
      .matches(/(?=.*[a-z])/, I18n.t('errors.passwordFieldError'))
      .trim(),
  },
  {
    id: 'passwordConfirmation',
    label: I18n.t('shared.confirmPassword'),
    name: 'passwordConfirmation',
    type: 'password',
    customValidation: false,
    validation: yup
      .string()
      .oneOf([yup.ref('password')], 'Passwords do not match.')
      .required(),
  },
];

const ResetPasswordForm = ({confirmForgotPassword, isLoading, resetPasswordByEmail}) => {
  return (
    <Fragment>
      <ResetPasswordFormLabel>
        {I18n.t('auth.resetPasswordLabel')}
      </ResetPasswordFormLabel>
      <ResetPasswordFormMessage>
        {resetPasswordByEmail ? I18n.t('auth.resetPasswordByEmailMessage') : I18n.t('auth.resetPasswordByPhoneMessage')}
      </ResetPasswordFormMessage>
      <Form
        fields={formFields}
        onSubmit={(...args) => {
          confirmForgotPassword(...args)
        }}
      >
        <Button disabled={isLoading} isLoading={isLoading} size={'full'} type={'submit'}>
          {I18n.t('auth.resetMyPassword')}
        </Button>
      </Form>
    </Fragment>
  )
};

ResetPasswordForm.propTypes = {
  confirmForgotPassword: PropTypes.func,
  isLoading: PropTypes.bool,
  resetPasswordByEmail: PropTypes.bool,
  username: PropTypes.string,
};

export default ResetPasswordForm
